var _toConsumableArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

module.exports = function (t) {
  var e = {};

  function n(r) {
    if (e[r]) return e[r].exports;
    var o = e[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = t, n.c = e, n.d = function (t, e, r) {
    n.o(t, e) || Object.defineProperty(t, e, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, n.t = function (t, e) {
    if (1 & e && (t = n(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var o in t) {
      n.d(r, o, function (e) {
        return t[e];
      }.bind(null, o));
    }
    return r;
  }, n.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return n.d(e, "a", e), e;
  }, n.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, n.p = "", n(n.s = 16);
}([function (t, e, n) {
  t.exports = n(11);
}, function (t, e) {
  function n(t, e, r) {
    if (!(this instanceof n)) return new n(t, e, r);
    this.x = "number" == typeof t ? t : 0, this.y = "number" == typeof e ? e : 0, this.z = "number" == typeof r ? r : 0;
  }

  n.ORIGIN = new n(0, 0, 0), n.prototype.translate = function (t, e, r) {
    return t = "number" == typeof t ? t : 0, e = "number" == typeof e ? e : 0, r = "number" == typeof r ? r : 0, new n(this.x + t, this.y + e, this.z + r);
  }, n.prototype.scale = function (t, e, n, r) {
    var o = this.translate(-t.x, -t.y, -t.z);
    return void 0 === n && void 0 === r ? n = r = e : r = "number" == typeof r ? r : 1, o.x *= e, o.y *= n, o.z *= r, o.translate(t.x, t.y, t.z);
  }, n.prototype.rotateX = function (t, e) {
    var n = this.translate(-t.x, -t.y, -t.z),
        r = n.z * Math.cos(e) - n.y * Math.sin(e),
        o = n.z * Math.sin(e) + n.y * Math.cos(e);
    return n.z = r, n.y = o, n.translate(t.x, t.y, t.z);
  }, n.prototype.rotateY = function (t, e) {
    var n = this.translate(-t.x, -t.y, -t.z),
        r = n.x * Math.cos(e) - n.z * Math.sin(e),
        o = n.x * Math.sin(e) + n.z * Math.cos(e);
    return n.x = r, n.z = o, n.translate(t.x, t.y, t.z);
  }, n.prototype.rotateZ = function (t, e) {
    var n = this.translate(-t.x, -t.y, -t.z),
        r = n.x * Math.cos(e) - n.y * Math.sin(e),
        o = n.x * Math.sin(e) + n.y * Math.cos(e);
    return n.x = r, n.y = o, n.translate(t.x, t.y, t.z);
  }, n.prototype.depth = function () {
    return this.x + this.y - 2 * this.z;
  }, n.distance = function (t, e) {
    var n = e.x - t.x,
        r = e.y - t.y,
        o = e.z - t.z;
    return Math.sqrt(n * n + r * r + o * o);
  }, t.exports = n;
}, function (t, e, n) {
  var r = n(1);

  function o(t) {
    "[object Array]" === Object.prototype.toString.call(t) ? this.points = t : this.points = Array.prototype.slice.call(arguments);
  }

  o.prototype.push = function (t) {
    this.points.push(t);
  }, o.prototype.reverse = function () {
    return new o(Array.prototype.slice.call(this.points).reverse());
  }, o.prototype.translate = function () {
    var t = arguments;
    return new o(this.points.map(function (e) {
      return e.translate.apply(e, t);
    }));
  }, o.prototype.rotateX = function () {
    var t = arguments;
    return new o(this.points.map(function (e) {
      return e.rotateX.apply(e, t);
    }));
  }, o.prototype.rotateY = function () {
    var t = arguments;
    return new o(this.points.map(function (e) {
      return e.rotateY.apply(e, t);
    }));
  }, o.prototype.rotateZ = function () {
    var t = arguments;
    return new o(this.points.map(function (e) {
      return e.rotateZ.apply(e, t);
    }));
  }, o.prototype.scale = function () {
    var t = arguments;
    return new o(this.points.map(function (e) {
      return e.scale.apply(e, t);
    }));
  }, o.prototype.depth = function () {
    var t,
        e = 0;

    for (t = 0; t < this.points.length; t++) {
      e += this.points[t].depth();
    }

    return e / (this.points.length || 1);
  }, o.Rectangle = function (t, e, n) {
    return void 0 === e && (e = 1), void 0 === n && (n = 1), new o([t, new r(t.x + e, t.y, t.z), new r(t.x + e, t.y + n, t.z), new r(t.x, t.y + n, t.z)]);
  }, o.Circle = function (t, e, n) {
    n = n || 20;
    var i,
        a = new o();

    for (i = 0; i < n; i++) {
      a.push(new r(e * Math.cos(2 * i * Math.PI / n), e * Math.sin(2 * i * Math.PI / n), 0));
    }

    return a.translate(t.x, t.y, t.z);
  }, o.Star = function (t, e, n, i) {
    var a,
        u,
        s = new o();

    for (a = 0; a < 2 * i; a++) {
      u = a % 2 == 0 ? e : n, s.push(new r(u * Math.cos(a * Math.PI / i), u * Math.sin(a * Math.PI / i), 0));
    }

    return s.translate(t.x, t.y, t.z);
  }, t.exports = o;
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var r = n(4);

  var o =
  /*#__PURE__*/
  function () {
    function o(t) {
      _classCallCheck(this, o);

      this.nodes = new Map(), this.addMultipleInternalNodes(t);
    }

    _createClass(o, [{
      key: "addNode",
      value: function addNode(t, e) {
        return this.addInternalNode(t, e);
      }
    }, {
      key: "addNodes",
      value: function addNodes(t) {
        this.addMultipleInternalNodes(t);
      }
    }, {
      key: "addEdge",
      value: function addEdge(t, e) {
        r(this.nodes.has(t), "Source node with ".concat(t, " key should exist")), r(this.nodes.has(e), "Target node with ".concat(e, " key should exist"));
        var n = this.nodes.get(t),
            o = this.nodes.get(e);
        r.strictEqual(void 0 !== n, !0, "Source node with key ".concat(t, " doesn't exist")), r.strictEqual(void 0 !== o, !0, "Target node with key ".concat(e, " doesn't exist")), r.strictEqual(n.children.has(e), !1, "Source node ".concat(t, " already has an adge to target node ").concat(e)), n.children.set(e, o);
      }
    }, {
      key: "sort",
      value: function sort() {
        this.visitedNodes = new Set(), this.sortedKeysStack = [];
        var t = new Map();
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref3 = _step.value;

            var _ref2 = _slicedToArray(_ref3, 1);

            var _t = _ref2[0];
            this.exploreNode(_t, []);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        for (var _e = this.sortedKeysStack.length - 1; _e >= 0; _e--) {
          var _n = this.nodes.get(this.sortedKeysStack[_e]);

          t.set(this.sortedKeysStack[_e], _n);
        }

        return t;
      }
    }, {
      key: "exploreNode",
      value: function exploreNode(t, e) {
        var n = [].concat(_toConsumableArray(e), [t]);
        e.length && r(!e.includes(t), "Node ".concat(t, " forms circular dependency: ").concat(n.join(" -> ")));
        var o = this.nodes.get(t);

        if (!this.visitedNodes.has(o)) {
          this.visitedNodes.add(o);
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = o.children[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var _ref6 = _step2.value;

              var _ref5 = _slicedToArray(_ref6, 1);

              var _t2 = _ref5[0];
              this.exploreNode(_t2, n);
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          this.sortedKeysStack.push(t);
        }
      }
    }, {
      key: "addInternalNode",
      value: function addInternalNode(t, e) {
        return r.strictEqual(this.nodes.has(t), !1, "Node ".concat(t, " already exists")), this.nodes.set(t, {
          children: new Map(),
          node: e
        }), this;
      }
    }, {
      key: "addMultipleInternalNodes",
      value: function addMultipleInternalNodes(t) {
        var e = _toConsumableArray(t);

        for (var _n2 = t.size - 1; _n2 >= 0; _n2--) {
          var _e$_n = _slicedToArray(e[_n2], 2),
              _t3 = _e$_n[0],
              _r = _e$_n[1];

          this.addInternalNode(_t3, _r);
        }
      }
    }]);

    return o;
  }();

  e.TopologicalSort = o, e.default = o;
}, function (t, e, n) {
  "use strict";

  (function (e) {
    var r = n(6);
    /*!
     * The buffer module from node.js, for the browser.
     *
     * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
     * @license  MIT
     */

    function o(t, e) {
      if (t === e) return 0;

      for (var n = t.length, r = e.length, o = 0, i = Math.min(n, r); o < i; ++o) {
        if (t[o] !== e[o]) {
          n = t[o], r = e[o];
          break;
        }
      }

      return n < r ? -1 : r < n ? 1 : 0;
    }

    function i(t) {
      return e.Buffer && "function" == typeof e.Buffer.isBuffer ? e.Buffer.isBuffer(t) : !(null == t || !t._isBuffer);
    }

    var a = n(7),
        u = Object.prototype.hasOwnProperty,
        s = Array.prototype.slice,
        c = "foo" === function () {}.name;

    function f(t) {
      return Object.prototype.toString.call(t);
    }

    function l(t) {
      return !i(t) && "function" == typeof e.ArrayBuffer && ("function" == typeof ArrayBuffer.isView ? ArrayBuffer.isView(t) : !!t && (t instanceof DataView || !!(t.buffer && t.buffer instanceof ArrayBuffer)));
    }

    var h = t.exports = v,
        p = /\s*function\s+([^\(\s]*)\s*/;

    function y(t) {
      if (a.isFunction(t)) {
        if (c) return t.name;
        var e = t.toString().match(p);
        return e && e[1];
      }
    }

    function d(t, e) {
      return "string" == typeof t ? t.length < e ? t : t.slice(0, e) : t;
    }

    function g(t) {
      if (c || !a.isFunction(t)) return a.inspect(t);
      var e = y(t);
      return "[Function" + (e ? ": " + e : "") + "]";
    }

    function b(t, e, n, r, o) {
      throw new h.AssertionError({
        message: n,
        actual: t,
        expected: e,
        operator: r,
        stackStartFunction: o
      });
    }

    function v(t, e) {
      t || b(t, !0, e, "==", h.ok);
    }

    function m(t, e, n, r) {
      if (t === e) return !0;
      if (i(t) && i(e)) return 0 === o(t, e);
      if (a.isDate(t) && a.isDate(e)) return t.getTime() === e.getTime();
      if (a.isRegExp(t) && a.isRegExp(e)) return t.source === e.source && t.global === e.global && t.multiline === e.multiline && t.lastIndex === e.lastIndex && t.ignoreCase === e.ignoreCase;

      if (null !== t && "object" == typeof t || null !== e && "object" == typeof e) {
        if (l(t) && l(e) && f(t) === f(e) && !(t instanceof Float32Array || t instanceof Float64Array)) return 0 === o(new Uint8Array(t.buffer), new Uint8Array(e.buffer));
        if (i(t) !== i(e)) return !1;
        var u = (r = r || {
          actual: [],
          expected: []
        }).actual.indexOf(t);
        return -1 !== u && u === r.expected.indexOf(e) || (r.actual.push(t), r.expected.push(e), function (t, e, n, r) {
          if (null == t || null == e) return !1;
          if (a.isPrimitive(t) || a.isPrimitive(e)) return t === e;
          if (n && Object.getPrototypeOf(t) !== Object.getPrototypeOf(e)) return !1;
          var o = w(t),
              i = w(e);
          if (o && !i || !o && i) return !1;
          if (o) return t = s.call(t), e = s.call(e), m(t, e, n);
          var u,
              c,
              f = P(t),
              l = P(e);
          if (f.length !== l.length) return !1;

          for (f.sort(), l.sort(), c = f.length - 1; c >= 0; c--) {
            if (f[c] !== l[c]) return !1;
          }

          for (c = f.length - 1; c >= 0; c--) {
            if (u = f[c], !m(t[u], e[u], n, r)) return !1;
          }

          return !0;
        }(t, e, n, r));
      }

      return n ? t === e : t == e;
    }

    function w(t) {
      return "[object Arguments]" == Object.prototype.toString.call(t);
    }

    function x(t, e) {
      if (!t || !e) return !1;
      if ("[object RegExp]" == Object.prototype.toString.call(e)) return e.test(t);

      try {
        if (t instanceof e) return !0;
      } catch (t) {}

      return !Error.isPrototypeOf(e) && !0 === e.call({}, t);
    }

    function O(t, e, n, r) {
      var o;
      if ("function" != typeof e) throw new TypeError('"block" argument must be a function');
      "string" == typeof n && (r = n, n = null), o = function (t) {
        var e;

        try {
          t();
        } catch (t) {
          e = t;
        }

        return e;
      }(e), r = (n && n.name ? " (" + n.name + ")." : ".") + (r ? " " + r : "."), t && !o && b(o, n, "Missing expected exception" + r);
      var i = "string" == typeof r,
          u = !t && o && !n;
      if ((!t && a.isError(o) && i && x(o, n) || u) && b(o, n, "Got unwanted exception" + r), t && o && n && !x(o, n) || !t && o) throw o;
    }

    h.AssertionError = function (t) {
      var e;
      this.name = "AssertionError", this.actual = t.actual, this.expected = t.expected, this.operator = t.operator, t.message ? (this.message = t.message, this.generatedMessage = !1) : (this.message = d(g((e = this).actual), 128) + " " + e.operator + " " + d(g(e.expected), 128), this.generatedMessage = !0);
      var n = t.stackStartFunction || b;
      if (Error.captureStackTrace) Error.captureStackTrace(this, n);else {
        var r = new Error();

        if (r.stack) {
          var o = r.stack,
              i = y(n),
              a = o.indexOf("\n" + i);

          if (a >= 0) {
            var u = o.indexOf("\n", a + 1);
            o = o.substring(u + 1);
          }

          this.stack = o;
        }
      }
    }, a.inherits(h.AssertionError, Error), h.fail = b, h.ok = v, h.equal = function (t, e, n) {
      t != e && b(t, e, n, "==", h.equal);
    }, h.notEqual = function (t, e, n) {
      t == e && b(t, e, n, "!=", h.notEqual);
    }, h.deepEqual = function (t, e, n) {
      m(t, e, !1) || b(t, e, n, "deepEqual", h.deepEqual);
    }, h.deepStrictEqual = function (t, e, n) {
      m(t, e, !0) || b(t, e, n, "deepStrictEqual", h.deepStrictEqual);
    }, h.notDeepEqual = function (t, e, n) {
      m(t, e, !1) && b(t, e, n, "notDeepEqual", h.notDeepEqual);
    }, h.notDeepStrictEqual = function t(e, n, r) {
      m(e, n, !0) && b(e, n, r, "notDeepStrictEqual", t);
    }, h.strictEqual = function (t, e, n) {
      t !== e && b(t, e, n, "===", h.strictEqual);
    }, h.notStrictEqual = function (t, e, n) {
      t === e && b(t, e, n, "!==", h.notStrictEqual);
    }, h.throws = function (t, e, n) {
      O(!0, t, e, n);
    }, h.doesNotThrow = function (t, e, n) {
      O(!1, t, e, n);
    }, h.ifError = function (t) {
      if (t) throw t;
    }, h.strict = r(function t(e, n) {
      e || b(e, !0, n, "==", t);
    }, h, {
      equal: h.strictEqual,
      deepEqual: h.deepStrictEqual,
      notEqual: h.notStrictEqual,
      notDeepEqual: h.notDeepStrictEqual
    }), h.strict.strict = h.strict;

    var P = Object.keys || function (t) {
      var e = [];

      for (var n in t) {
        u.call(t, n) && e.push(n);
      }

      return e;
    };
  }).call(this, n(5));
}, function (t, e) {
  var n;

  n = function () {
    return this;
  }();

  try {
    n = n || new Function("return this")();
  } catch (t) {
    "object" == typeof window && (n = window);
  }

  t.exports = n;
}, function (t, e, n) {
  "use strict";
  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */

  var r = Object.getOwnPropertySymbols,
      o = Object.prototype.hasOwnProperty,
      i = Object.prototype.propertyIsEnumerable;

  function a(t) {
    if (null == t) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(t);
  }

  t.exports = function () {
    try {
      if (!Object.assign) return !1;
      var t = new String("abc");
      if (t[5] = "de", "5" === Object.getOwnPropertyNames(t)[0]) return !1;

      for (var e = {}, n = 0; n < 10; n++) {
        e["_" + String.fromCharCode(n)] = n;
      }

      if ("0123456789" !== Object.getOwnPropertyNames(e).map(function (t) {
        return e[t];
      }).join("")) return !1;
      var r = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (t) {
        r[t] = t;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
    } catch (t) {
      return !1;
    }
  }() ? Object.assign : function (t, e) {
    for (var n, u, s = a(t), c = 1; c < arguments.length; c++) {
      for (var f in n = Object(arguments[c])) {
        o.call(n, f) && (s[f] = n[f]);
      }

      if (r) {
        u = r(n);

        for (var l = 0; l < u.length; l++) {
          i.call(n, u[l]) && (s[u[l]] = n[u[l]]);
        }
      }
    }

    return s;
  };
}, function (t, e, n) {
  (function (t) {
    var r = Object.getOwnPropertyDescriptors || function (t) {
      for (var e = Object.keys(t), n = {}, r = 0; r < e.length; r++) {
        n[e[r]] = Object.getOwnPropertyDescriptor(t, e[r]);
      }

      return n;
    },
        o = /%[sdj%]/g;

    e.format = function (t) {
      if (!b(t)) {
        for (var e = [], n = 0; n < arguments.length; n++) {
          e.push(u(arguments[n]));
        }

        return e.join(" ");
      }

      n = 1;

      for (var r = arguments, i = r.length, a = String(t).replace(o, function (t) {
        if ("%%" === t) return "%";
        if (n >= i) return t;

        switch (t) {
          case "%s":
            return String(r[n++]);

          case "%d":
            return Number(r[n++]);

          case "%j":
            try {
              return JSON.stringify(r[n++]);
            } catch (t) {
              return "[Circular]";
            }

          default:
            return t;
        }
      }), s = r[n]; n < i; s = r[++n]) {
        d(s) || !w(s) ? a += " " + s : a += " " + u(s);
      }

      return a;
    }, e.deprecate = function (n, r) {
      if (void 0 !== t && !0 === t.noDeprecation) return n;
      if (void 0 === t) return function () {
        return e.deprecate(n, r).apply(this, arguments);
      };
      var o = !1;
      return function () {
        if (!o) {
          if (t.throwDeprecation) throw new Error(r);
          t.traceDeprecation ? console.trace(r) : console.error(r), o = !0;
        }

        return n.apply(this, arguments);
      };
    };
    var i,
        a = {};

    function u(t, n) {
      var r = {
        seen: [],
        stylize: c
      };
      return arguments.length >= 3 && (r.depth = arguments[2]), arguments.length >= 4 && (r.colors = arguments[3]), y(n) ? r.showHidden = n : n && e._extend(r, n), v(r.showHidden) && (r.showHidden = !1), v(r.depth) && (r.depth = 2), v(r.colors) && (r.colors = !1), v(r.customInspect) && (r.customInspect = !0), r.colors && (r.stylize = s), f(r, t, r.depth);
    }

    function s(t, e) {
      var n = u.styles[e];
      return n ? "[" + u.colors[n][0] + "m" + t + "[" + u.colors[n][1] + "m" : t;
    }

    function c(t, e) {
      return t;
    }

    function f(t, n, r) {
      if (t.customInspect && n && P(n.inspect) && n.inspect !== e.inspect && (!n.constructor || n.constructor.prototype !== n)) {
        var o = n.inspect(r, t);
        return b(o) || (o = f(t, o, r)), o;
      }

      var i = function (t, e) {
        if (v(e)) return t.stylize("undefined", "undefined");

        if (b(e)) {
          var n = "'" + JSON.stringify(e).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
          return t.stylize(n, "string");
        }

        if (g(e)) return t.stylize("" + e, "number");
        if (y(e)) return t.stylize("" + e, "boolean");
        if (d(e)) return t.stylize("null", "null");
      }(t, n);

      if (i) return i;

      var a = Object.keys(n),
          u = function (t) {
        var e = {};
        return t.forEach(function (t, n) {
          e[t] = !0;
        }), e;
      }(a);

      if (t.showHidden && (a = Object.getOwnPropertyNames(n)), O(n) && (a.indexOf("message") >= 0 || a.indexOf("description") >= 0)) return l(n);

      if (0 === a.length) {
        if (P(n)) {
          var s = n.name ? ": " + n.name : "";
          return t.stylize("[Function" + s + "]", "special");
        }

        if (m(n)) return t.stylize(RegExp.prototype.toString.call(n), "regexp");
        if (x(n)) return t.stylize(Date.prototype.toString.call(n), "date");
        if (O(n)) return l(n);
      }

      var c,
          w = "",
          j = !1,
          S = ["{", "}"];
      (p(n) && (j = !0, S = ["[", "]"]), P(n)) && (w = " [Function" + (n.name ? ": " + n.name : "") + "]");
      return m(n) && (w = " " + RegExp.prototype.toString.call(n)), x(n) && (w = " " + Date.prototype.toUTCString.call(n)), O(n) && (w = " " + l(n)), 0 !== a.length || j && 0 != n.length ? r < 0 ? m(n) ? t.stylize(RegExp.prototype.toString.call(n), "regexp") : t.stylize("[Object]", "special") : (t.seen.push(n), c = j ? function (t, e, n, r, o) {
        for (var i = [], a = 0, u = e.length; a < u; ++a) {
          k(e, String(a)) ? i.push(h(t, e, n, r, String(a), !0)) : i.push("");
        }

        return o.forEach(function (o) {
          o.match(/^\d+$/) || i.push(h(t, e, n, r, o, !0));
        }), i;
      }(t, n, r, u, a) : a.map(function (e) {
        return h(t, n, r, u, e, j);
      }), t.seen.pop(), function (t, e, n) {
        if (t.reduce(function (t, e) {
          return e.indexOf("\n") >= 0 && 0, t + e.replace(/\u001b\[\d\d?m/g, "").length + 1;
        }, 0) > 60) return n[0] + ("" === e ? "" : e + "\n ") + " " + t.join(",\n  ") + " " + n[1];
        return n[0] + e + " " + t.join(", ") + " " + n[1];
      }(c, w, S)) : S[0] + w + S[1];
    }

    function l(t) {
      return "[" + Error.prototype.toString.call(t) + "]";
    }

    function h(t, e, n, r, o, i) {
      var a, u, s;

      if ((s = Object.getOwnPropertyDescriptor(e, o) || {
        value: e[o]
      }).get ? u = s.set ? t.stylize("[Getter/Setter]", "special") : t.stylize("[Getter]", "special") : s.set && (u = t.stylize("[Setter]", "special")), k(r, o) || (a = "[" + o + "]"), u || (t.seen.indexOf(s.value) < 0 ? (u = d(n) ? f(t, s.value, null) : f(t, s.value, n - 1)).indexOf("\n") > -1 && (u = i ? u.split("\n").map(function (t) {
        return "  " + t;
      }).join("\n").substr(2) : "\n" + u.split("\n").map(function (t) {
        return "   " + t;
      }).join("\n")) : u = t.stylize("[Circular]", "special")), v(a)) {
        if (i && o.match(/^\d+$/)) return u;
        (a = JSON.stringify("" + o)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (a = a.substr(1, a.length - 2), a = t.stylize(a, "name")) : (a = a.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), a = t.stylize(a, "string"));
      }

      return a + ": " + u;
    }

    function p(t) {
      return Array.isArray(t);
    }

    function y(t) {
      return "boolean" == typeof t;
    }

    function d(t) {
      return null === t;
    }

    function g(t) {
      return "number" == typeof t;
    }

    function b(t) {
      return "string" == typeof t;
    }

    function v(t) {
      return void 0 === t;
    }

    function m(t) {
      return w(t) && "[object RegExp]" === j(t);
    }

    function w(t) {
      return "object" == typeof t && null !== t;
    }

    function x(t) {
      return w(t) && "[object Date]" === j(t);
    }

    function O(t) {
      return w(t) && ("[object Error]" === j(t) || t instanceof Error);
    }

    function P(t) {
      return "function" == typeof t;
    }

    function j(t) {
      return Object.prototype.toString.call(t);
    }

    function S(t) {
      return t < 10 ? "0" + t.toString(10) : t.toString(10);
    }

    e.debuglog = function (n) {
      if (v(i) && (i = t.env.NODE_DEBUG || ""), n = n.toUpperCase(), !a[n]) if (new RegExp("\\b" + n + "\\b", "i").test(i)) {
        var r = t.pid;

        a[n] = function () {
          var t = e.format.apply(e, arguments);
          console.error("%s %d: %s", n, r, t);
        };
      } else a[n] = function () {};
      return a[n];
    }, e.inspect = u, u.colors = {
      bold: [1, 22],
      italic: [3, 23],
      underline: [4, 24],
      inverse: [7, 27],
      white: [37, 39],
      grey: [90, 39],
      black: [30, 39],
      blue: [34, 39],
      cyan: [36, 39],
      green: [32, 39],
      magenta: [35, 39],
      red: [31, 39],
      yellow: [33, 39]
    }, u.styles = {
      special: "cyan",
      number: "yellow",
      boolean: "yellow",
      undefined: "grey",
      null: "bold",
      string: "green",
      date: "magenta",
      regexp: "red"
    }, e.isArray = p, e.isBoolean = y, e.isNull = d, e.isNullOrUndefined = function (t) {
      return null == t;
    }, e.isNumber = g, e.isString = b, e.isSymbol = function (t) {
      return "symbol" == typeof t;
    }, e.isUndefined = v, e.isRegExp = m, e.isObject = w, e.isDate = x, e.isError = O, e.isFunction = P, e.isPrimitive = function (t) {
      return null === t || "boolean" == typeof t || "number" == typeof t || "string" == typeof t || "symbol" == typeof t || void 0 === t;
    }, e.isBuffer = n(9);
    var z = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    function E() {
      var t = new Date(),
          e = [S(t.getHours()), S(t.getMinutes()), S(t.getSeconds())].join(":");
      return [t.getDate(), z[t.getMonth()], e].join(" ");
    }

    function k(t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }

    e.log = function () {
      console.log("%s - %s", E(), e.format.apply(e, arguments));
    }, e.inherits = n(10), e._extend = function (t, e) {
      if (!e || !w(e)) return t;

      for (var n = Object.keys(e), r = n.length; r--;) {
        t[n[r]] = e[n[r]];
      }

      return t;
    };
    var M = "undefined" != typeof Symbol ? Symbol("util.promisify.custom") : void 0;

    function I(t, e) {
      if (!t) {
        var n = new Error("Promise was rejected with a falsy value");
        n.reason = t, t = n;
      }

      return e(t);
    }

    e.promisify = function (t) {
      if ("function" != typeof t) throw new TypeError('The "original" argument must be of type Function');

      if (M && t[M]) {
        var e;
        if ("function" != typeof (e = t[M])) throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        return Object.defineProperty(e, M, {
          value: e,
          enumerable: !1,
          writable: !1,
          configurable: !0
        }), e;
      }

      function e() {
        for (var e, n, r = new Promise(function (t, r) {
          e = t, n = r;
        }), o = [], i = 0; i < arguments.length; i++) {
          o.push(arguments[i]);
        }

        o.push(function (t, r) {
          t ? n(t) : e(r);
        });

        try {
          t.apply(this, o);
        } catch (t) {
          n(t);
        }

        return r;
      }

      return Object.setPrototypeOf(e, Object.getPrototypeOf(t)), M && Object.defineProperty(e, M, {
        value: e,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), Object.defineProperties(e, r(t));
    }, e.promisify.custom = M, e.callbackify = function (e) {
      if ("function" != typeof e) throw new TypeError('The "original" argument must be of type Function');

      function n() {
        for (var n = [], r = 0; r < arguments.length; r++) {
          n.push(arguments[r]);
        }

        var o = n.pop();
        if ("function" != typeof o) throw new TypeError("The last argument must be of type Function");

        var i = this,
            a = function a() {
          return o.apply(i, arguments);
        };

        e.apply(this, n).then(function (e) {
          t.nextTick(a, null, e);
        }, function (e) {
          t.nextTick(I, e, a);
        });
      }

      return Object.setPrototypeOf(n, Object.getPrototypeOf(e)), Object.defineProperties(n, r(e)), n;
    };
  }).call(this, n(8));
}, function (t, e) {
  var n,
      r,
      o = t.exports = {};

  function i() {
    throw new Error("setTimeout has not been defined");
  }

  function a() {
    throw new Error("clearTimeout has not been defined");
  }

  function u(t) {
    if (n === setTimeout) return setTimeout(t, 0);
    if ((n === i || !n) && setTimeout) return n = setTimeout, setTimeout(t, 0);

    try {
      return n(t, 0);
    } catch (e) {
      try {
        return n.call(null, t, 0);
      } catch (e) {
        return n.call(this, t, 0);
      }
    }
  }

  !function () {
    try {
      n = "function" == typeof setTimeout ? setTimeout : i;
    } catch (t) {
      n = i;
    }

    try {
      r = "function" == typeof clearTimeout ? clearTimeout : a;
    } catch (t) {
      r = a;
    }
  }();
  var s,
      c = [],
      f = !1,
      l = -1;

  function h() {
    f && s && (f = !1, s.length ? c = s.concat(c) : l = -1, c.length && p());
  }

  function p() {
    if (!f) {
      var t = u(h);
      f = !0;

      for (var e = c.length; e;) {
        for (s = c, c = []; ++l < e;) {
          s && s[l].run();
        }

        l = -1, e = c.length;
      }

      s = null, f = !1, function (t) {
        if (r === clearTimeout) return clearTimeout(t);
        if ((r === a || !r) && clearTimeout) return r = clearTimeout, clearTimeout(t);

        try {
          r(t);
        } catch (e) {
          try {
            return r.call(null, t);
          } catch (e) {
            return r.call(this, t);
          }
        }
      }(t);
    }
  }

  function y(t, e) {
    this.fun = t, this.array = e;
  }

  function d() {}

  o.nextTick = function (t) {
    var e = new Array(arguments.length - 1);
    if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
      e[n - 1] = arguments[n];
    }
    c.push(new y(t, e)), 1 !== c.length || f || u(p);
  }, y.prototype.run = function () {
    this.fun.apply(null, this.array);
  }, o.title = "browser", o.browser = !0, o.env = {}, o.argv = [], o.version = "", o.versions = {}, o.on = d, o.addListener = d, o.once = d, o.off = d, o.removeListener = d, o.removeAllListeners = d, o.emit = d, o.prependListener = d, o.prependOnceListener = d, o.listeners = function (t) {
    return [];
  }, o.binding = function (t) {
    throw new Error("process.binding is not supported");
  }, o.cwd = function () {
    return "/";
  }, o.chdir = function (t) {
    throw new Error("process.chdir is not supported");
  }, o.umask = function () {
    return 0;
  };
}, function (t, e) {
  t.exports = function (t) {
    return t && "object" == typeof t && "function" == typeof t.copy && "function" == typeof t.fill && "function" == typeof t.readUInt8;
  };
}, function (t, e) {
  "function" == typeof Object.create ? t.exports = function (t, e) {
    t.super_ = e, t.prototype = Object.create(e.prototype, {
      constructor: {
        value: t,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    });
  } : t.exports = function (t, e) {
    t.super_ = e;

    var n = function n() {};

    n.prototype = e.prototype, t.prototype = new n(), t.prototype.constructor = t;
  };
}, function (t, e, n) {
  var r = n(12),
      o = n(13),
      i = n(2),
      a = n(1),
      u = n(14),
      s = n(15);

  function c(t, e) {
    e = e || {}, this.canvas = new r(t), this.angle = Math.PI / 6, this.scale = e.scale || 70, this._calculateTransformation(), this.originX = e.originX || this.canvas.width / 2, this.originY = e.originY || .9 * this.canvas.height, this.lightPosition = e.lightPosition || new s(2, -1, 3), this.lightAngle = this.lightPosition.normalize(), this.colorDifference = .2, this.lightColor = e.lightColor || new o(255, 255, 255);
  }

  c.prototype.setLightPosition = function (t, e, n) {
    this.lightPosition = new s(t, e, n), this.lightAngle = this.lightPosition.normalize();
  }, c.prototype._translatePoint = function (t) {
    var e = new a(t.x * this.transformation[0][0], t.x * this.transformation[0][1]),
        n = new a(t.y * this.transformation[1][0], t.y * this.transformation[1][1]),
        r = this.originX + e.x + n.x,
        o = this.originY - e.y - n.y - t.z * this.scale;
    return new a(r, o);
  }, c.prototype.add = function (t, e) {
    if ("[object Array]" == Object.prototype.toString.call(t)) for (var n = 0; n < t.length; n++) {
      this.add(t[n], e);
    } else if (t instanceof i) this._addPath(t, e);else if (t instanceof u) for (var r = t.orderedPaths(), o = 0; o < r.length; o++) {
      this._addPath(r[o], e);
    }
  }, c.prototype._addPath = function (t, e) {
    e = e || new o(120, 120, 120);
    var n = s.fromTwoPoints(t.points[1], t.points[0]),
        r = s.fromTwoPoints(t.points[2], t.points[1]),
        i = s.crossProduct(n, r).normalize(),
        a = s.dotProduct(i, this.lightAngle),
        u = e.lighten(a * this.colorDifference, this.lightColor);
    this.canvas.path(t.points.map(this._translatePoint.bind(this)), u);
  }, c.prototype._calculateTransformation = function () {
    this.transformation = [[this.scale * Math.cos(this.angle), this.scale * Math.sin(this.angle)], [this.scale * Math.cos(Math.PI - this.angle), this.scale * Math.sin(Math.PI - this.angle)]];
  }, c.Canvas = r, c.Color = o, c.Path = i, c.Point = a, c.Shape = u, c.Vector = s, t.exports = c;
}, function (t, e) {
  function n(t) {
    this.elem = t, this.ctx = this.elem.getContext("2d"), this.width = t.width, this.height = t.height;
  }

  n.prototype.clear = function () {
    this.ctx.clearRect(0, 0, this.width, this.height);
  }, n.prototype.path = function (t, e) {
    this.ctx.beginPath(), this.ctx.moveTo(t[0].x, t[0].y);

    for (var n = 1; n < t.length; n++) {
      this.ctx.lineTo(t[n].x, t[n].y);
    }

    this.ctx.closePath(), this.ctx.save(), this.ctx.globalAlpha = e.a, this.ctx.fillStyle = this.ctx.strokeStyle = e.toHex(), this.ctx.stroke(), this.ctx.fill(), this.ctx.restore();
  }, t.exports = n;
}, function (t, e) {
  function n(t, e, n, r) {
    this.r = parseInt(t || 0), this.g = parseInt(e || 0), this.b = parseInt(n || 0), this.a = parseFloat(Math.round(100 * r) / 100 || 1), this.loadHSL();
  }

  n.prototype.toHex = function () {
    var t = (256 * this.r * 256 + 256 * this.g + this.b).toString(16);
    return t.length < 6 && (t = new Array(6 - t.length + 1).join("0") + t), "#" + t;
  }, n.prototype.lighten = function (t, e) {
    e = e || new n(255, 255, 255);
    var r = new n(e.r / 255 * this.r, e.g / 255 * this.g, e.b / 255 * this.b, this.a);
    return r.l = Math.min(r.l + t, 1), r.loadRGB(), r;
  }, n.prototype.loadHSL = function () {
    var t,
        e,
        n = this.r / 255,
        r = this.g / 255,
        o = this.b / 255,
        i = Math.max(n, r, o),
        a = Math.min(n, r, o),
        u = (i + a) / 2;
    if (i === a) t = e = 0;else {
      var s = i - a;

      switch (e = u > .5 ? s / (2 - i - a) : s / (i + a), i) {
        case n:
          t = (r - o) / s + (r < o ? 6 : 0);
          break;

        case r:
          t = (o - n) / s + 2;
          break;

        case o:
          t = (n - r) / s + 4;
      }

      t /= 6;
    }
    this.h = t, this.s = e, this.l = u;
  }, n.prototype.loadRGB = function () {
    var t,
        e,
        n,
        r = this.h,
        o = this.s,
        i = this.l;
    if (0 === o) t = e = n = i;else {
      var a = i < .5 ? i * (1 + o) : i + o - i * o,
          u = 2 * i - a;
      t = this._hue2rgb(u, a, r + 1 / 3), e = this._hue2rgb(u, a, r), n = this._hue2rgb(u, a, r - 1 / 3);
    }
    this.r = parseInt(255 * t), this.g = parseInt(255 * e), this.b = parseInt(255 * n);
  }, n.prototype._hue2rgb = function (t, e, n) {
    return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + 6 * (e - t) * n : n < .5 ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t;
  }, t.exports = n;
}, function (t, e, n) {
  var r = n(2),
      o = n(1);

  function i(t) {
    "[object Array]" === Object.prototype.toString.call(t) ? this.paths = t : this.paths = Array.prototype.slice.call(arguments);
  }

  i.prototype.push = function (t) {
    this.paths.push(t);
  }, i.prototype.translate = function () {
    var t = arguments;
    return new i(this.paths.map(function (e) {
      return e.translate.apply(e, t);
    }));
  }, i.prototype.rotateX = function () {
    var t = arguments;
    return new i(this.paths.map(function (e) {
      return e.rotateX.apply(e, t);
    }));
  }, i.prototype.rotateY = function () {
    var t = arguments;
    return new i(this.paths.map(function (e) {
      return e.rotateY.apply(e, t);
    }));
  }, i.prototype.rotateZ = function () {
    var t = arguments;
    return new i(this.paths.map(function (e) {
      return e.rotateZ.apply(e, t);
    }));
  }, i.prototype.scale = function () {
    var t = arguments;
    return new i(this.paths.map(function (e) {
      return e.scale.apply(e, t);
    }));
  }, i.prototype.orderedPaths = function () {
    return this.paths.slice().sort(function (t, e) {
      return e.depth() - t.depth();
    });
  }, i.extrude = function (t, e) {
    e = "number" == typeof e ? e : 1;
    var n,
        o = t.translate(0, 0, e),
        a = new i();

    for (a.push(t.reverse()), a.push(o), n = 0; n < t.points.length; n++) {
      a.push(new r([o.points[n], t.points[n], t.points[(n + 1) % t.points.length], o.points[(n + 1) % o.points.length]]));
    }

    return a;
  }, i.Prism = function (t, e, n, a) {
    e = "number" == typeof e ? e : 1, n = "number" == typeof n ? n : 1, a = "number" == typeof a ? a : 1;
    var u = new i(),
        s = new r([t, new o(t.x + e, t.y, t.z), new o(t.x + e, t.y, t.z + a), new o(t.x, t.y, t.z + a)]);
    u.push(s), u.push(s.reverse().translate(0, n, 0));
    var c = new r([t, new o(t.x, t.y, t.z + a), new o(t.x, t.y + n, t.z + a), new o(t.x, t.y + n, t.z)]);
    u.push(c), u.push(c.reverse().translate(e, 0, 0));
    var f = new r([t, new o(t.x + e, t.y, t.z), new o(t.x + e, t.y + n, t.z), new o(t.x, t.y + n, t.z)]);
    return u.push(f.reverse()), u.push(f.translate(0, 0, a)), u;
  }, i.Pyramid = function (t, e, n, a) {
    e = "number" == typeof e ? e : 1, n = "number" == typeof n ? n : 1, a = "number" == typeof a ? a : 1;
    var u = new i(),
        s = new r([t, new o(t.x + e, t.y, t.z), new o(t.x + e / 2, t.y + n / 2, t.z + a)]);
    u.push(s), u.push(s.rotateZ(t.translate(e / 2, n / 2), Math.PI));
    var c = new r([t, new o(t.x + e / 2, t.y + n / 2, t.z + a), new o(t.x, t.y + n, t.z)]);
    return u.push(c), u.push(c.rotateZ(t.translate(e / 2, n / 2), Math.PI)), u;
  }, i.Cylinder = function (t, e, n, o) {
    e = "number" == typeof e ? e : 1;
    var a = r.Circle(t, e, n);
    return i.extrude(a, o);
  }, t.exports = i;
}, function (t, e) {
  function n(t, e, n) {
    this.i = "number" == typeof t ? t : 0, this.j = "number" == typeof e ? e : 0, this.k = "number" == typeof n ? n : 0;
  }

  n.fromTwoPoints = function (t, e) {
    return new n(e.x - t.x, e.y - t.y, e.z - t.z);
  }, n.crossProduct = function (t, e) {
    return new n(t.j * e.k - e.j * t.k, -1 * (t.i * e.k - e.i * t.k), t.i * e.j - e.i * t.j);
  }, n.dotProduct = function (t, e) {
    return t.i * e.i + t.j * e.j + t.k * e.k;
  }, n.prototype.magnitude = function () {
    return Math.sqrt(this.i * this.i + this.j * this.j + this.k * this.k);
  }, n.prototype.normalize = function () {
    var t = this.magnitude();
    return 0 === t ? new n(0, 0, 0) : new n(this.i / t, this.j / t, this.k / t);
  }, t.exports = n;
}, function (t, e, n) {
  "use strict";

  n.r(e);

  var r = n(3),
      o = n(0),
      i = n.n(o),
      a = "x",
      u = "y",
      s = "UP",
      c = "DOWN",
      f = (new o.Color(44, 102, 101), new o.Color(59, 188, 188)),
      l = new o.Color(252, 116, 102),
      h = function h(t, e) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
        r = Math.round(t.x) - Math.round(e.x),
        o = Math.round(t.y) - Math.round(e.y),
        i = Math.round(t.z) - Math.round(e.z);

    switch (n) {
      case .25:
        return r === i && o === -i;

      case .5:
        return r === i && o === i;

      case .75:
        return r === -i && o === i;

      case 0:
      default:
        return r === -i && o === -i;
    }
  },
      p = function p(t) {
    for (var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2 * Math.PI / 4, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 16, r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3], i = r ? -n : 0; i <= n; i += 1) {
      t.add(new o.Path([new o.Point(i, (r ? -1 : 0) * n, 0), new o.Point(i, n, 0), new o.Point(i, (r ? -1 : 0) * n, 0)]).rotateZ(Object(o.Point)(n / 2, n / 2, 0), e), f), t.add(new o.Path([new o.Point((r ? -1 : 0) * n, i, 0), new o.Point(n, i, 0), new o.Point((r ? -1 : 0) * n, i, 0)]).rotateZ(Object(o.Point)(n / 2, n / 2, 0), e), l);
    }
  },
      y = function y(t) {
    var e = {
      xmin: 1 / 0,
      xmax: -1 / 0,
      ymin: 1 / 0,
      ymax: -1 / 0,
      zmin: 1 / 0,
      zmax: -1 / 0,
      hmin: 1 / 0,
      hmax: -1 / 0
    };
    return t.shape.paths.forEach(function (t) {
      t.points.forEach(function (t) {
        var n,
            r,
            o,
            i = (r = (n = t).x + n.z, o = n.y + n.z, {
          x: r,
          y: o,
          h: (r - o) * Math.cos(Math.PI / 6),
          v: (r + o) / 2
        });
        e.xmin = Math.min(e.xmin, Math.round(1e3 * i.x) / 1e3), e.xmax = Math.max(e.xmax, Math.round(1e3 * i.x) / 1e3), e.ymin = Math.min(e.ymin, Math.round(1e3 * i.y) / 1e3), e.ymax = Math.max(e.ymax, Math.round(1e3 * i.y) / 1e3), e.zmin = Math.min(e.zmin, Math.round(1e3 * t.z) / 1e3), e.zmax = Math.max(e.zmax, Math.round(1e3 * t.z) / 1e3), e.hmin = Math.min(e.hmin, Math.round(1e3 * i.h) / 1e3), e.hmax = Math.max(e.hmax, Math.round(1e3 * i.h) / 1e3);
      });
    }), e;
  },
      d = function d(t, e) {
    return !(t.xmin > e.xmax || e.xmin > t.xmax || t.ymin > e.ymax || e.ymin > t.ymax || t.hmin > e.hmax || e.hmin > t.hmax);
  },
      g = function g(t) {
    return t.xmax + t.ymax - 4 * t.zmax;
  },
      b = function b(t, e) {
    return g(t) <= g(e);
  };

  function v(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  }

  function m(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }

  function w(t, e, n) {
    return e in t ? Object.defineProperty(t, e, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = n, t;
  }

  var x = function () {
    function t(e) {
      var n = this,
          r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
          i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1,
          a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
      v(this, t), w(this, "setColor", function (t) {
        return n.color = t, n;
      }), w(this, "setShape", function (t) {
        return n.shape = t, n;
      }), this.dx = r, this.dy = i, this.dz = a, this.origin = Object(o.Point)(Math.round(1e3 * e.x) / 1e3, Math.round(1e3 * e.y) / 1e3, Math.round(1e3 * e.z) / 1e3), this.color = void 0, this.shape = new o.Shape.Prism(e, r, i, a);
    }

    var e, n, r;
    return e = t, (n = [{
      key: "getId",
      value: function value() {
        return "".concat(this.origin.x, ",").concat(this.origin.y, ",").concat(this.origin.z, "--").concat(this.dx, "x").concat(this.dy, "x").concat(this.dz);
      }
    }, {
      key: "rotateX",
      value: function value() {
        var t;
        return this.shape = (t = this.shape).rotateX.apply(t, arguments), this;
      }
    }, {
      key: "rotateY",
      value: function value() {
        var t;
        return this.shape = (t = this.shape).rotateY.apply(t, arguments), this;
      }
    }, {
      key: "rotateZ",
      value: function value() {
        var t;
        return this.shape = (t = this.shape).rotateZ.apply(t, arguments), this;
      }
    }]) && m(e.prototype, n), r && m(e, r), t;
  }();

  function O(t) {
    return function (t) {
      if (Array.isArray(t)) return P(t);
    }(t) || function (t) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
    }(t) || function (t, e) {
      if (!t) return;
      if ("string" == typeof t) return P(t, e);
      var n = Object.prototype.toString.call(t).slice(8, -1);
      "Object" === n && t.constructor && (n = t.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(n);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return P(t, e);
    }(t) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function P(t, e) {
    (null == e || e > t.length) && (e = t.length);

    for (var n = 0, r = new Array(e); n < e; n++) {
      r[n] = t[n];
    }

    return r;
  }

  function j(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }

  var S = function () {
    function t(e, n, r, i, a) {
      var u,
          s,
          c,
          f = this;
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, t), c = function c(t) {
        return f.color = t, f.blocks = f.blocks.map(function (e) {
          return e.setColor(t);
        }), f;
      }, (s = "setColor") in (u = this) ? Object.defineProperty(u, s, {
        value: c,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : u[s] = c, this.dx = n, this.dy = r, this.dz = i, this.origin = Object(o.Point)(Math.round(1e3 * e.x) / 1e3, Math.round(1e3 * e.y) / 1e3, Math.round(1e3 * e.z) / 1e3), this.direction = a, this.color = void 0, this.blocks = [];
    }

    var e, n, r;
    return e = t, (n = [{
      key: "getRotationStartPoint",
      value: function value() {
        return Object(o.Point)(this.origin.x + .5, this.origin.y + .5, this.origin.z + .5);
      }
    }, {
      key: "getRotationCenterPoint",
      value: function value() {
        return Object(o.Point)(this.origin.x + this.dx / 2, this.origin.y + this.dy / 2, this.origin.z + this.dz / 2);
      }
    }, {
      key: "getRotationEndPoint",
      value: function value() {
        return Object(o.Point)(this.origin.x + this.dx - .5, this.origin.y + this.dy - .5, this.origin.z + this.dz - .5);
      }
    }, {
      key: "rotateXStart",
      value: function value(t) {
        return this.rotateX(this.getRotationStartPoint(), t);
      }
    }, {
      key: "rotateXStart",
      value: function value(t) {
        return this.rotateY(this.getRotationStartPoint(), t);
      }
    }, {
      key: "rotateZStart",
      value: function value(t) {
        return this.rotateZ(this.getRotationStartPoint(), t);
      }
    }, {
      key: "rotateXCenter",
      value: function value(t) {
        return this.rotateX(this.getRotationCenterPoint(), t);
      }
    }, {
      key: "rotateYCenter",
      value: function value(t) {
        return this.rotateY(this.getRotationCenterPoint(), t);
      }
    }, {
      key: "rotateZCenter",
      value: function value(t) {
        return this.rotateZ(this.getRotationCenterPoint(), t);
      }
    }, {
      key: "rotateXEnd",
      value: function value(t) {
        return this.rotateX(this.getRotationEndPoint(), t);
      }
    }, {
      key: "rotateYEnd",
      value: function value(t) {
        return this.rotateY(this.getRotationEndPoint(), t);
      }
    }, {
      key: "rotateZEnd",
      value: function value(t) {
        return this.rotateZ(this.getRotationEndPoint(), t);
      }
    }, {
      key: "rotateAlongAxis",
      value: function value(t) {
        var e = this.getRotationEndPoint();
        return this.direction === s || this.direction === c ? this.rotateZ(e, t) : this.direction === a ? this.rotateX(e, t) : this.rotateY(e, t);
      }
    }, {
      key: "rotateX",
      value: function value() {
        var t = arguments;
        return this.blocks = this.blocks.map(function (e) {
          return e.rotateX.apply(e, O(t));
        }), this;
      }
    }, {
      key: "rotateY",
      value: function value() {
        var t = arguments;
        return this.blocks = this.blocks.map(function (e) {
          return e.rotateY.apply(e, O(t));
        }), this;
      }
    }, {
      key: "rotateZ",
      value: function value() {
        var t = arguments;
        return this.blocks = this.blocks.map(function (e) {
          return e.rotateZ.apply(e, O(t));
        }), this;
      }
    }]) && j(e.prototype, n), r && j(e, r), t;
  }();

  function z(t) {
    return (z = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }

  function E(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }

  function k(t, e) {
    return (k = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    })(t, e);
  }

  function M(t, e) {
    return !e || "object" !== z(e) && "function" != typeof e ? function (t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }(t) : e;
  }

  function I() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
    } catch (t) {
      return !1;
    }
  }

  function T(t) {
    return (T = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }

  var A = function (t) {
    !function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && k(t, e);
    }(c, t);
    var e,
        n,
        r,
        i,
        s = (e = c, function () {
      var t,
          n = T(e);

      if (I()) {
        var r = T(this).constructor;
        t = Reflect.construct(n, arguments, r);
      } else t = n.apply(this, arguments);

      return M(this, t);
    });

    function c(t, e, n) {
      var r;
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, c);
      var i = n === a ? Math.abs(e) : 1,
          f = n === u ? Math.abs(e) : 1;
      r = s.call(this, t, i, f, 1, n);

      for (var l = 0; l < Math.abs(e); l += 1) {
        r.blocks.push(new x(Object(o.Point)(t.x + (n === a ? l : 0), t.y + (n === u ? l : 0), t.z)));
      }

      return r;
    }

    return n = c, (r = [{
      key: "addStartExtrusion",
      value: function value() {
        var t = Object(o.Point)(this.origin.x - (this.direction === a ? 1 : 0), this.origin.y - (this.direction === u ? 1 : 0), this.origin.z),
            e = new o.Path([t, Object(o.Point)(t.x + 1, t.y, t.z), Object(o.Point)(t.x + 1, t.y + 1, t.z)]),
            n = new x(t, 1, 1, 1).setColor(this.color).setShape(o.Shape.extrude(e, 1)),
            r = Object(o.Point)(t.x + .5, t.y + .5, t.z + .5);
        return this.blocks.push(this.direction === a ? n.rotateX(r, 3 * -Math.PI / 2) : n.rotateY(r, 3 * -Math.PI / 2).rotateZ(r, Math.PI)), this;
      }
    }, {
      key: "addEndExtrusion",
      value: function value() {
        var t = Object(o.Point)(this.origin.x + this.dx - (this.direction === u ? 1 : 0), this.origin.y + this.dy - (this.direction === a ? 1 : 0), this.origin.z),
            e = new o.Path([t, Object(o.Point)(t.x + 1, t.y, t.z), Object(o.Point)(t.x + 1, t.y + 1, t.z)]),
            n = new x(t, 1, 1, 1).setColor(this.color).setShape(o.Shape.extrude(e, 1)),
            r = Object(o.Point)(t.x + .5, t.y + .5, t.z + .5);
        return this.blocks.push(this.direction === a ? n.rotateX(r, -Math.PI / 2).rotateZ(r, Math.PI) : n.rotateY(r, -Math.PI / 2)), this;
      }
    }]) && E(n.prototype, r), i && E(n, i), c;
  }(S);

  function _(t) {
    return (_ = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }

  function R(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }

  function C(t, e) {
    return (C = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    })(t, e);
  }

  function D(t, e) {
    return !e || "object" !== _(e) && "function" != typeof e ? function (t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }(t) : e;
  }

  function q() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
    } catch (t) {
      return !1;
    }
  }

  function N(t) {
    return (N = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }

  var Z = function (t) {
    !function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && C(t, e);
    }(u, t);
    var e,
        n,
        r,
        i,
        a = (e = u, function () {
      var t,
          n = N(e);

      if (q()) {
        var r = N(this).constructor;
        t = Reflect.construct(n, arguments, r);
      } else t = n.apply(this, arguments);

      return D(this, t);
    });

    function u(t, e, n) {
      var r;
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, u), r = a.call(this, t, 1, 1, e, n);

      for (var i = 0; i < Math.abs(e); i += 1) {
        r.blocks.push(new x(Object(o.Point)(t.x, t.y, t.z + i)));
      }

      return r;
    }

    return n = u, (r = [{
      key: "addStartExtrusion",
      value: function value() {
        var t = Object(o.Point)(this.origin.x, this.origin.y, this.origin.z - 1),
            e = new o.Path([t, Object(o.Point)(t.x + 1, t.y, t.z), Object(o.Point)(t.x + 1, t.y + 1, t.z)]),
            n = Object(o.Point)(t.x + .5, t.y + .5, t.z + .5);
        return this.blocks.push(new x(t, 1, 1, 1).setColor(this.color).setShape(o.Shape.extrude(e, 1)).rotateY(n, Math.PI / 2).rotateX(n, 3 * -Math.PI / 2)), this;
      }
    }, {
      key: "addEndExtrusion",
      value: function value() {
        var t = this.getRotationEndPoint(),
            e = Object(o.Point)(t.x - .5, t.y - .5, t.z + .5),
            n = new o.Path([e, Object(o.Point)(e.x + 1, e.y, e.z), Object(o.Point)(e.x + 1, e.y + 1, e.z)]),
            r = Object(o.Point)(e.x + .5, e.y + .5, e.z + .5);
        return this.blocks.push(new x(e, 1, 1, 1).setColor(this.color).setShape(o.Shape.extrude(n, 1)).rotateY(r, Math.PI / 2).rotateX(r, -Math.PI / 2)), this;
      }
    }]) && R(n.prototype, r), i && R(n, i), u;
  }(S);

  function X(t) {
    return (X = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }

  function Y(t) {
    return function (t) {
      if (Array.isArray(t)) return G(t);
    }(t) || function (t) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
    }(t) || function (t, e) {
      if (!t) return;
      if ("string" == typeof t) return G(t, e);
      var n = Object.prototype.toString.call(t).slice(8, -1);
      "Object" === n && t.constructor && (n = t.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(n);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return G(t, e);
    }(t) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function G(t, e) {
    (null == e || e > t.length) && (e = t.length);

    for (var n = 0, r = new Array(e); n < e; n++) {
      r[n] = t[n];
    }

    return r;
  }

  function B(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  }

  function F(t, e) {
    return (F = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    })(t, e);
  }

  function $(t, e) {
    return !e || "object" !== X(e) && "function" != typeof e ? function (t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }(t) : e;
  }

  function U() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
    } catch (t) {
      return !1;
    }
  }

  function H(t) {
    return (H = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }

  var L = function (t) {
    !function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && F(t, e);
    }(r, t);
    var e,
        n = (e = r, function () {
      var t,
          n = H(e);

      if (U()) {
        var r = H(this).constructor;
        t = Reflect.construct(n, arguments, r);
      } else t = n.apply(this, arguments);

      return $(this, t);
    });

    function r(t, e, i) {
      var s,
          c = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 5;
      B(this, r);
      var f = i === a ? e : 1,
          l = i === u ? e : 1,
          h = e;
      s = n.call(this, t, f, l, h, i);
      var p = t;
      return Y(Array(e).keys()).forEach(function (t, e) {
        Y(Array(c).keys()).forEach(function (t, n) {
          0 === e && 0 === n || (p = Object(o.Point)(p.x + (i === a ? 1 / c : 0), p.y + (i === u ? 1 / c : 0), p.z + 1 / c)), s.blocks.push(new x(p, i === a ? 1 / c : 1, i === u ? 1 / c : 1, 1 / c));
        });
      }), s;
    }

    return r;
  }(S);

  function J(t) {
    return function (t) {
      if (Array.isArray(t)) return Q(t);
    }(t) || function (t) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
    }(t) || function (t, e) {
      if (!t) return;
      if ("string" == typeof t) return Q(t, e);
      var n = Object.prototype.toString.call(t).slice(8, -1);
      "Object" === n && t.constructor && (n = t.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(n);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Q(t, e);
    }(t) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function Q(t, e) {
    (null == e || e > t.length) && (e = t.length);

    for (var n = 0, r = new Array(e); n < e; n++) {
      r[n] = t[n];
    }

    return r;
  }

  function K(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  }

  function V(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }

  function W(t, e, n) {
    return e in t ? Object.defineProperty(t, e, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = n, t;
  }

  var tt = function tt(t) {
    return t;
  },
      et = function () {
    function t(e) {
      var n = this,
          l = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Object(o.Point)(0, 0, 0),
          g = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : f;
      return K(this, t), W(this, "getEquivalentPoint", function (t) {
        for (var e = [], r = 0; r < n.blockGroups.length; r++) {
          var i = n.blockGroups[r],
              f = i.origin,
              l = i.dz,
              p = i.direction;

          if (p === a) {
            var y = Object(o.Point)(f.x + 1, f.y, f.z + l);
            h(t, y, n.rotationQuadrant) && e.push(y);
          }

          if (p === u) {
            var d = Object(o.Point)(f.x, f.y + 1, f.z + l);
            h(t, d, n.rotationQuadrant) && e.push(d);
          }

          if (p === c) {
            var g = Object(o.Point)(f.x, f.y, f.z + l);
            h(t, g, n.rotationQuadrant) && e.push(g);
          }

          if (p === s) {
            var b = Object(o.Point)(f.x, f.y, f.z + l);
            h(t, b, n.rotationQuadrant) && !h(t, Object(o.Point)(b.x, b.y, b.z + 1)) && e.push(b);
          }
        }

        if (0 !== e.length) return e.sort(function (t, e) {
          return e.z - t.z;
        })[0];
      }), W(this, "clearCanvas", function () {
        n.iso.canvas.ctx.clearRect(0, 0, n.iso.canvas.elem.width, n.iso.canvas.elem.height);
      }), W(this, "setColor", function (t) {
        return n.color = t, n;
      }), W(this, "setDelay", function (t) {
        return n.delay = t, n;
      }), W(this, "updateOrigin", function () {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
            e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
        return n.setOrigin(Object(o.Point)(n.origin.x + t, n.origin.y + e, n.origin.z + r));
      }), W(this, "setOrigin", function (t) {
        return n.origin = t, n;
      }), W(this, "setGridSize", function (t) {
        return n.gridSize = t, n;
      }), W(this, "addColumn", function (t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : s,
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : tt;
        return e === c && n.updateOrigin(0, 0, -1 * (t - 1)), n.blockGroups.push(r(new Z(n.origin, t, e))), e === c && n.updateOrigin(0, 0, -1), n.updateOrigin(0, 0, t);
      }), W(this, "addTrack", function (t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : a,
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : tt,
            o = e === a ? Math.abs(t) : 1,
            i = e === u ? Math.abs(t) : 1;

        if (t < 0) {
          n.updateOrigin(e === a ? -1 * (o - 1) : 0, e === u ? -1 * (i - 1) : 0, 0);
          var s = r(new A(n.origin, t, e));
          return n.blockGroups.push(s), n.direction = e, n;
        }

        n.direction = e, n.updateOrigin(e === a && n.direction !== a ? 1 : 0, e === u && n.direction !== u ? 1 : 0);
        var c = r(new A(n.origin, t, e));
        return n.blockGroups.push(c), n.updateOrigin(e === a ? o : 0, e === u ? i : 0, 0);
      }), W(this, "addStairs", function (t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : a,
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 5,
            o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : tt;
        return n.updateOrigin(e === a ? 1 : 0, e === u ? 1 : 0, 1), n.blockGroups.push(o(new L(n.origin, t, e, r))), n.updateOrigin(e === a ? t : 0, e === u ? t : 0, t - 1), n.direction = e, n;
      }), W(this, "addBlock", function (t) {
        return n.blockGroups.push(t), n;
      }), W(this, "addBlocks", function (t) {
        return n.blockGroups = n.blockGroups.concat(t), n;
      }), W(this, "drawGrid", function (t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        return n.gridSize = t || n.gridSize, p(n.iso, n.rotation, n.gridSize, e), n;
      }), W(this, "buildNodes", function (t) {
        var e = new Map();
        return t.forEach(function (t) {
          e.set(t.getId(), t);
        }), n.topology = new r.TopologicalSort(e), n;
      }), W(this, "addEdge", function (t, e) {
        return n.topology.nodes.get(t.getId()).children.has(e.getId()) || n.topology.addEdge(t.getId(), e.getId()), n;
      }), W(this, "buildEdges", function (t) {
        return t.forEach(function (e, r) {
          t.slice(r + 1).forEach(function (t) {
            var r = y(e),
                o = y(t);
            e.getId() !== t.getId() && d(r, o) && (b(r, o) ? n.addEdge(e, t) : n.addEdge(t, e));
          });
        }), n;
      }), W(this, "delayDraw", function (t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
        return e ? setTimeout(function () {
          n.iso.add(t.shape, t.color || n.color);
        }, e) : n.iso.add(t.shape, t.color || n.color), n;
      }), W(this, "draw", function () {
        n.topology = null, n.nodes = new Map();
        var t = n.blockGroups.reduce(function (t, e) {
          return [].concat(J(t), J(e.blocks));
        }, []).map(function (t) {
          return t.rotateZ(Object(o.Point)(n.gridSize / 2, n.gridSize / 2, 0), n.rotation);
        });
        n.buildNodes(t), n.buildEdges(t);
        var e = null;

        try {
          J((e = n.topology.sort()).keys()).reverse().forEach(function (t, r) {
            var o = e.get(t).node;
            n.delayDraw(o, r * n.delay);
          });
        } catch (t) {
          console.log(t, console.log(n.topology));
        }

        return n;
      }), W(this, "flush", function () {
        return n.blockGroups = [], n;
      }), this.canvas = e, this.iso = new i.a(e), this.iso.colorDifference = .35, this.origin = l, this.gridSize = 16, this.blockGroups = [], this.direction = null, this.color = g, this.rotation = 0, this.rotationQuadrant = 0, this.delay = 0, this.topology = null, this;
    }

    var e, n, l;
    return e = t, (n = [{
      key: "split",
      value: function value() {
        return new t(this.canvas, this.origin).setRotation(this.rotation);
      }
    }, {
      key: "rotate",
      value: function value() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Math.PI / 8;
        return this.setRotation(this.rotation + t);
      }
    }, {
      key: "setRotation",
      value: function value() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Math.PI / 8;
        return this.rotation = t, this.rotationQuadrant = Math.abs(.25 * Math.round(Math.abs(2 * Math.PI - this.rotation) / Math.PI / 2 % 1 / .25)) % 1, this;
      }
    }]) && V(e.prototype, n), l && V(e, l), t;
  }();

  e.default = et;
}]);